import { Environment } from './environment.model';

export const environment: Environment = {
  production: true,
  baseUrl: 'https://vivest.com.br',
  apiPerfilInvestimentoUrl: 'api-perfil-investimento',
  apiGatewayPrefix: 'apis',
  // 5 = TipoCampanha.Suitability (COD_CAMPANHA) na API; o portal só resolve campanhas com esse código.
  defaultCodCampanha: 5,
  secretPortal: '29ff1cf960bc6fe3a4bd29d22ba65dedffcc85f5a1d76d09ac825e6b0a047eba',
  // TODO: subscription key do APIM de produção (não é a de HML) — pegar com a infra.
  subscriptionKeyPortalVivestCenter: '',
  allowDevAuthBypass: false,
};
